/**
 * 退款服务：创建退款申请、查询我的退款记录。
 *
 * @module services/refund
 */
import type { RefundRequest } from '@/types';
import { API } from '@/config/api';
import { request } from './http';

/** 创建退款申请入参。 */
export interface CreateRefundInput {
  amount: string | number;
  reason: string;
}

/** 创建退款申请。 */
export async function createRefund(
  input: CreateRefundInput,
): Promise<RefundRequest> {
  return request<RefundRequest>({
    method: 'POST',
    url: API.refund.create,
    data: input,
  });
}

/** 查询我的退款记录。 */
export async function listMyRefunds(): Promise<RefundRequest[]> {
  return request<RefundRequest[]>({ method: 'GET', url: API.refund.list });
}
